// API utility functions
export const getApiBaseUrl = () => {
  // Always use direct backend API (bypassing Worker proxy)
  return 'https://api.guiltbox.me/api';
};

export const apiRequest = async (endpoint, options = {}) => {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}${endpoint}`;
  
  // Add basic auth headers when needed
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  // Always add basic auth (backend will check if it's enabled)
  headers['Authorization'] = 'Basic ' + btoa('admin:Asdfg1maj*');
  
  const response = await fetch(url, {
    ...options,
    headers,
  });
  
  if (!response.ok) {
    throw new Error(`API request failed: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
};